<template>
    <div class="modal-roomlist">
        <div class="modal">
            <div class="modal-header">
                <div style="padding: 6px;">物品修改</div>
                <button type="button" class="btn-close" @click="closeSelf">关闭</button>
            </div>
            <div class="modal-body">
                <el-form :model="editForm" :rules="rules" ref="editForm">
                    <div>
                        <el-row>
                            <el-col :span="12" class="item">
                                <el-form-item label="物品名称" required prop="name">
                                    <el-input v-model="editForm.name"  placeholder="请输入物品名称"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12" class="item">
                                <el-form-item label="物品单价" required prop="price">
                                    <el-input v-model="editForm.price" type="number"  placeholder="请输入物品单价"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12" class="item">
                                <el-form-item label="库存" required prop="stock">
                                    <el-input v-model.number="editForm.stock" placeholder="请输入库存"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12" class="item">
                                <el-form-item label="供应商" required prop="supplierCode">
                                    <el-select v-model="editForm.supplierCode" placeholder="请选择供应商" style="width:100%">
                                        <el-option
                                                v-for="item in SupplierCodeValue"
                                                :key="item.supplierCode"
                                                :label="item.name"
                                                :value="item.supplierCode">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12" class="item">
                                <el-form-item label="物品类型" required prop="waresTypeCode">
                                    <el-select v-model="editForm.waresTypeCode" placeholder="请选择物品类型" style="width:100%">
                                        <el-option
                                                v-for="item in WaresTypeCodeValue"
                                                :key="item.waresTypeCode"
                                                :label="item.name"
                                                :value="item.waresTypeCode">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                      
                            <el-col :span="12" class="item">
                                <el-form-item label="仓库" required prop="warehouseCode">
                                    <el-select v-model="editForm.warehouseCode" placeholder="请选择仓库" style="width:100%">
                                        <el-option
                                                v-for="item in warehouseCodeValue"
                                                :key="item.warehouseCode"
                                                :label="item.name"
                                                :value="item.warehouseCode">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12" class="item">
                                <el-form-item label="物品状态" required prop="status">
                                    <el-select v-model="editForm.status" placeholder="选择职工状态" style="width:100%">
                                        <el-option
                                                v-for="item in status2"
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item.value">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            
                        </el-row>
                    </div>

                </el-form>


            </div>
            <div class="modal-footer">
                <el-button :loading="loading" type="primary" @click="confirm('editForm')">修改</el-button>
            </div>
        </div>
    </div>
</template>

<script>

    import {timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";
    import {getStaffCode} from "@/utils/auth";

    export default {
        name: 'Edit',
        props: ["SupplierCodeValue","WaresTypeCodeValue",'warehouseCodeValue'],
        data() {
            return {
                loading: false,
                editForm:{
                    timeStr:timeStr,
                    sign:'',
                    staffCode:getStaffCode(),
                    name:'',
                    price:'',
                    waresCode:'',
                    waresTypeCode:'',
                    supplierCode:'',
                    warehouseCode:'',
                    stock:'',
                    status:''
                },
                status2: [{
                    value: 0,
                    label: '正常'
                }, {
                    value: 1,
                    label: '被禁用'
                }],
                rules:{
                    stock:[
                        { required: true, message: '请输入库存', trigger: 'blur' },
                        { type: 'number', message: '排序必须为数字值'}
                    ],
                    price:[
                        { required: true, message: '请输入物品单价', trigger: 'blur' },
                        {
                            pattern: /^(\d?)+(\.\d{0,2})?$/,
                            message: '请输入正确的金额(保留两位小数)', trigger: 'blur'
                        },
                    ],
                    warehouseCode:[
                        { required: true, message: '请选择仓库', trigger: 'blur' },
                    ],
                    name:[
                        { required: true, message: '请输入物品名称', trigger: 'blur' },
                    ],
                    waresTypeCode:[
                        { required: true, message: '请选择物品类型', trigger: 'blur' },
                    ],
                    supplierCode:[
                        { required: true, message: '请选择供应商', trigger: 'blur' },
                    ],
                }

            }
        },

        methods: {

            init(row){
                this.editForm.name = row.name;
                this.editForm.waresTypeCode = row.waresTypeCode;
                this.editForm.warehouseCode = row.warehouseCode;
                this.editForm.waresCode = row.waresCode;
                this.editForm.price = row.price;
                this.editForm.supplierCode = row.supplierCode;
                this.editForm.stock = row.stock;
                this.editForm.status = row.status;
            },
            closeSelf() {
                this.$emit("closeEdit");
            },

            confirm(editForm){
                this.$refs[editForm].validate((valid) => {
                    if(valid){
                        this.addSubmit();
                    }else {
                        console.log('error submit!!');
                        return false;
                    }
                })


            },

            addSubmit(){

                if(this.loading){
                    return;
                }else{
                    this.loading = true;
                }

                this.editForm.sign = hex_md5("timeStr=" + timeStr + "&key="+this.$signKey);

                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+"Wares/Edit",
                    data: this.editForm
                }).then(
                    (response) => {
                        this.loading = false;
                        if (response.data.error == 0) {
                            this.$emit("closeEdit");
                            this.$emit("getList");
                        }else if(response.data.error == 1){
                            this.$message({type: 'info', message: response.data.message});
                        }
                    }
                )
            },

        }
    }


</script>





<style lang="scss" scoped>

    .modal-roomlist {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background-color: rgba(0,0,0,.3);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 99;
        
        .modal {
            
            background-color: #fff;
            box-shadow:   0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
            overflow-x:auto;
            display: flex;
            flex-direction: column;
            border-radius: 10px;
            width: 600px;

            

            .modal-header {
                border-bottom: 1px solid #eee;
                color: #313131;
                justify-content: space-between;
                padding: 10px;
                display: flex;
            }
            .modal-body {
                position: relative;
                padding: 20px 0px;
                z-index: 99;
                height: 100%;
            }
            .modal-footer {
                border-top: 1px solid #eee;
                justify-content: flex-end;
                padding: 15px;
                display: flex;
            }


        }

    }


    .btn-close, .btn-confirm {
        border-radius: 8px;
        margin-left:16px;
        width:56px;
        height: 36px;
        border:none;
        cursor: pointer;
    }
    .btn-close {
        color: #313131;
        background-color:transparent;
    }



    .row{
        padding: 10px 0px;
    }
    .item{
        padding: 0px 20px;
    }
    .label{
        padding: 5px 0px;
    }


</style>
